export const HTMLStoreInformation = 'store-information-map'
